import React from "react";
import { StepConnector, stepConnectorClasses, StepIconProps, styled } from "@mui/material";
import { TouchApp, Key, CheckCircle } from "@mui/icons-material";

export const StyledConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: "linear-gradient(95deg, #0BA5EC 0%, #0EA5E9 50%, #10B981 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: "linear-gradient(95deg, #0BA5EC 0%, #0EA5E9 50%, #10B981 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: theme.palette.divider,
    borderRadius: 1,
  },
}));

const StyledStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.divider,
  zIndex: 1,
  color: theme.palette.text.secondary,
  width: 48,
  height: 48,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage: "linear-gradient(135deg, #0BA5EC 0%, #0EA5E9 100%)",
    boxShadow: "0 4px 10px 0 rgba(11, 165, 236, .25)",
    color: "#fff",
  }),
  ...(ownerState.completed && {
    backgroundImage: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
    color: "#fff",
  }),
}));

export const StyledStepIcon = (props: StepIconProps) => {
  const { active, completed, className, icon } = props;
  const icons: { [index: string]: React.ReactElement } = {
    1: <TouchApp />,
    2: <Key />,
  };

  return (
    <StyledStepIconRoot ownerState={{ completed, active }} className={className}>
      {completed ? <CheckCircle /> : icons[String(icon)]}
    </StyledStepIconRoot>
  );
};
